export type Images = {
  lg: string
  md: string
  sm: string
  ipfs?: string
}

export type PageMeta = {
  title: string
  description?: string
  image?: string
}

export type NumberFormatType =
  | 'significant'
  | 'percentage'
  | 'percentageInt'
  | 'toUSD'
  | 'toIntUSD'
  | 'compact'
  | 'compactPercent'

export enum FetchStatus {
  IDLE = 'IDLE',
  FETCHING = 'FETCHING',
  FETCHED = 'FETCHED',
  FAILED = 'FAILED',
}
